/**
 * Extract error message from API response
 * Handles FastAPI validation errors and other error formats
 */
export const getErrorMessage = (error, defaultMessage = "Une erreur est survenue") => {
  if (!error.response?.data?.detail) {
    return defaultMessage;
  }

  const detail = error.response.data.detail;

  // If detail is a string, return it directly
  if (typeof detail === 'string') {
    return detail;
  }

  // If detail is an array (FastAPI validation errors)
  if (Array.isArray(detail)) {
    return detail.map(err => {
      // Extract the error message
      if (typeof err === 'string') return err;
      if (err.msg) return err.msg;
      return JSON.stringify(err);
    }).join(', ');
  }

  // If detail is an object
  if (typeof detail === 'object') {
    if (detail.msg) return detail.msg;
    return JSON.stringify(detail);
  }

  return defaultMessage;
};
